module.exports = __webpack_public_path__ + "static/media/stream_masterskya_video_classes.1e6f9bd6.svg";